const FUNCTIONAL_ROUTE_WHITELIST = [
  '/',
  '/translate-pdf',
  '/translate-office',
  '/translate-ebook',
  '/translate-subtitle',
  '/pay'
];

const FUNCTIONAL_ROUTE_SET = new Set(FUNCTIONAL_ROUTE_WHITELIST);
const SUPPORTED_LOCALE_SET = new Set(['zh', 'en']);

function normalizePath(path) {
  const raw = String(path ?? '').trim();
  const withoutQuery = raw.split('?')[0]?.split('#')[0] ?? '';
  if (withoutQuery.length === 0) return '/';

  let normalized = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  normalized = normalized.replace(/\/{2,}/g, '/');
  if (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }
  return normalized || '/';
}

function normalizeFunctionalPath(path) {
  const normalized = normalizePath(path);
  const segments = normalized.split('/').filter(Boolean);
  if (segments.length === 0) {
    return '/';
  }

  const first = segments[0];
  if (!SUPPORTED_LOCALE_SET.has(first)) {
    return normalized;
  }
  if (segments.length === 1) {
    return '/';
  }
  return `/${segments.slice(1).join('/')}`;
}

function isFunctionalRoute(path) {
  return FUNCTIONAL_ROUTE_SET.has(normalizeFunctionalPath(path));
}

function shouldShowNewUserBanner(path, isLoggedIn, isDismissed = false) {
  if (Boolean(isLoggedIn) || Boolean(isDismissed)) {
    return false;
  }
  return isFunctionalRoute(path);
}

export {
  FUNCTIONAL_ROUTE_WHITELIST,
  isFunctionalRoute,
  normalizeFunctionalPath,
  shouldShowNewUserBanner
};
